(function () {
    'use strict';

    function SettingInfoComponentController(__config, $scope, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams, CompanyCustom) {
        //
        var color_red = '#e1655d';
        var color_blue = '#00A4CC';
        var color_green = '#2BAE66';
        var color_pink = '#DF6589';
        var color_purple = '#5D4494';
        var color_darkBlue = '#1A2238';
        var color_orange = '#F2AA4C';


        var $ctrl = this;
        $ctrl.__config = __config;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.resultx = 'x';
        $ctrl.sendBookingConfirmationSMS = false;
        $ctrl.sendBookingConfirmationEMAIL = false;
        $ctrl.switch_changed = switch_changed;
        $ctrl.sampleCheck = sampleCheck;
        $ctrl.sendBookingConfirmationMSGsample = false;
        $ctrl.sendBookingConfirmationSupplierMSGsample = false;
        $ctrl.sendBookingCancellationSupplierMSGsample = false;
        $ctrl.sendCustomerReminder = false;
        $ctrl.sendCustomerSecondReminder = false;
        $ctrl.sendCustomerBirthdateNotice = false;
        $ctrl.sendCustomerWelcome = false;

        $ctrl.sendBookingConfirmationSupplierSMS = false;
        $ctrl.sendBookingConfirmationSupplierEMAIL = false;
        $ctrl.sendUserRegistrationMessageSMS = false;
        $ctrl.sendUserRegistrationMessageEMAIL = false;
        $ctrl.sendCustomerSatisfactionMessageSMS = false;
        $ctrl.sendCustomerSatisfactionMessageEMAIL = false;
        $ctrl.sendCustomerReminderSMS = false;
        $ctrl.sendCustomerReminderEMAIL = false;

        $ctrl.sendCustomerSecondReminderSMS = false;
        $ctrl.sendCustomerSecondReminderEMAIL = false;

        $ctrl.sendCustomerRebookReminderSMS = false;
        $ctrl.sendCustomerRebookReminderEMAIL = false;

        $ctrl.sendBookingCancellationSupplierSMS = false;
        $ctrl.sendBookingCancellationSupplierEMAIL = false;
        $ctrl.sendCustomerBirthdateNoticeSMS = false;
        $ctrl.sendCustomerBirthdateNoticeEmail = false;
        $ctrl.sendCustomerWelcomeSMS = false;
        $ctrl.sendCustomerWelcomeEMAIL = false;

        $ctrl.settingFormSection = $stateParams.settingFormSection;
        $ctrl.isModernTheme = isModernTheme;
        $ctrl.primaryColorSet = 'PURPLE';
        $ctrl.primaryColorSetChanged = primaryColorSetChanged;
        $ctrl.colorSetStyle = colorSetStyle;
        $ctrl.colorList = ['RED', 'BLUE', 'GREEN', 'PINK', 'PURPLE', 'ORANGE', 'DARKBLUE', 'CUSTOM']
        $ctrl.company = null

        $ctrl.test = loadSwitches;
        $ctrl.videoPlatformChanged = videoPlatformChanged;
        $ctrl.imageUploaded = imageUploaded;

        loadAll();
        loadPage();


        //loadSwitches();
        function loadAll() {


            function onSuccess(data, headers) {


            }

            function onError(error) {
                AlertService.error(error.data.message);
            }


        }

        function loadPage(page) {
            translatePartialLoader.addPart('settingInfo');
            translatePartialLoader.addPart('notificationSetting');
            translatePartialLoader.addPart('financialSetting');
            translatePartialLoader.addPart('themeSettingInfo');
            translatePartialLoader.addPart('notificationType');
            translatePartialLoader.addPart('currency');
            translatePartialLoader.addPart('imageData');
            translatePartialLoader.addPart('themeType');
            translatePartialLoader.addPart('themeHeaderType');
            translatePartialLoader.addPart('themeServiceListType');
            translatePartialLoader.addPart('videoCallSettingInfo');
            translatePartialLoader.addPart('videoPlatformType');
            translatePartialLoader.addPart('visibilityStatus');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            findCurrentCompany()
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }


        function country_changed() {
            //
            //if(vm.SettingInfo.locationInfo.countryId!=null)
            //    vm.provinceList=SelectorDataQuery.findByTypeAndParent('province',vm.SettingInfo.locationInfo.countryId).query();
            //if(vm.SettingInfo.locationInfo.stateId!=null)
            //    vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.SettingInfo.locationInfo.stateId).query();
        }

        function province_changed() {
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.locationInfo.stateId).query();
        }

        function sampleCheck(msg) {
            $ctrl.sendBookingConfirmationMSGsample = false;
            $ctrl.sendBookingConfirmationSupplierMSGsample = false;
            $ctrl.sendCustomerReminder = false;
            $ctrl.sendCustomerRebookReminder = false;
            $ctrl.sendCustomerSecondReminder = false;
            $ctrl.sendCustomerBirthdateNotice = false

            msg === 'sendBookingConfirmation' ? $ctrl.sendBookingConfirmationMSGsample = true : false;
            msg === 'sendBookingConfirmationSupplier' ? $ctrl.sendBookingConfirmationSupplierMSGsample = true : false;
            msg === 'sendCustomerReminder' ? $ctrl.sendCustomerReminder = true : false;
            msg === 'sendCustomerRebookReminder' ? $ctrl.sendCustomerRebookReminder = true : false;
            msg === 'sendCustomerSecondReminder' ? $ctrl.sendCustomerSecondReminder = true : false;
            msg === 'sendBookingCancellationSupplier' ? $ctrl.sendBookingCancellationSupplierMSGsample = true : false;
            msg === 'customerBirthdateNoticeMsg' ? $ctrl.sendCustomerBirthdateNotice = true : false;
            msg === 'customerWelcom' ? $ctrl.sendCustomerWelcome = true : false;
        }

        function switch_changed() {
            $ctrl.settingInfo.notificationSetting.sendBookingConfirmation = setNotificationTypes($ctrl.sendBookingConfirmationSMS, $ctrl.sendBookingConfirmationEMAIL);
            $ctrl.settingInfo.notificationSetting.sendBookingConfirmationSupplier = setNotificationTypes($ctrl.sendBookingConfirmationSupplierSMS, $ctrl.sendBookingConfirmationSupplierEMAIL);
            $ctrl.settingInfo.notificationSetting.sendUserRegistrationMessage = setNotificationTypes($ctrl.sendUserRegistrationMessageSMS, $ctrl.sendUserRegistrationMessageEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerSatisfactionMessage = setNotificationTypes($ctrl.sendCustomerSatisfactionMessageSMS, $ctrl.sendCustomerSatisfactionMessageEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerReminder = setNotificationTypes($ctrl.sendCustomerReminderSMS, $ctrl.sendCustomerReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerRebookReminder = setNotificationTypes($ctrl.sendCustomerRebookReminderSMS, $ctrl.sendCustomerRebookReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerSecondReminder = setNotificationTypes($ctrl.sendCustomerSecondReminderSMS, $ctrl.sendCustomerSecondReminderEMAIL);
            $ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier = setNotificationTypes($ctrl.sendBookingCancellationSupplierSMS, $ctrl.sendBookingCancellationSupplierEMAIL);
            $ctrl.settingInfo.notificationSetting.sendCustomerBirthdateNotice = setNotificationTypes($ctrl.sendCustomerBirthdateNoticeSMS, $ctrl.sendCustomerBirthdateNoticeEmail)
            $ctrl.settingInfo.notificationSetting.sendCustomerWelcome = setNotificationTypes($ctrl.sendCustomerWelcomeSMS, $ctrl.sendCustomerWelcomeEMAIL)
            
        }

        function setNotificationTypes(smsType, emailType) {
            var result = "NONE";
            if (smsType && !emailType)
                result = "SMS";
            if (!smsType && emailType)
                result = "EMAIL";
            if (smsType && emailType)
                result = "SMS_AND_EMAIL";

            return result;

        }


        function loadSwitches() {
            //SendBookingConfirmation
            var switchSendBookingConfirmation = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingConfirmation);
            var switchSendBookingConfirmationSupplier = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingConfirmationSupplier);
            var switchSendUserRegistrationMessage = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendUserRegistrationMessage);
            var switchSendCustomerSatisfactionMessage = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerSatisfactionMessage);
            var switchSendCustomerReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerReminder);
            var switchSendCustomerRebookReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerRebookReminder);
            var switchSendCustomerSecondReminder = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerSecondReminder);
            var switchSendBookingCancellationSupplier = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier);
            var switchSendCustomerBirthdateNotice = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerBirthdateNotice);
            var switchSendCustomerWelcome = switchesByNotificationType($ctrl.settingInfo.notificationSetting.sendCustomerWelcome);

            $ctrl.sendBookingConfirmationSMS = switchSendBookingConfirmation.SMS;
            $ctrl.sendBookingConfirmationEMAIL = switchSendBookingConfirmation.EMAIL;

            $ctrl.sendBookingConfirmationSupplierSMS = switchSendBookingConfirmationSupplier.SMS;
            $ctrl.sendBookingConfirmationSupplierEMAIL = switchSendBookingConfirmationSupplier.EMAIL;

            $ctrl.sendUserRegistrationMessageSMS = switchSendUserRegistrationMessage.SMS;
            $ctrl.sendUserRegistrationMessageEMAIL = switchSendUserRegistrationMessage.EMAIL;

            $ctrl.sendCustomerSatisfactionMessageSMS = switchSendCustomerSatisfactionMessage.SMS;
            $ctrl.sendCustomerSatisfactionMessageEMAIL = switchSendCustomerSatisfactionMessage.EMAIL;

            $ctrl.sendCustomerReminderSMS = switchSendCustomerReminder.SMS;
            $ctrl.sendCustomerReminderEMAIL = switchSendCustomerReminder.EMAIL;

            $ctrl.sendCustomerRebookReminderSMS = switchSendCustomerRebookReminder.SMS;
            $ctrl.sendCustomerRebookReminderEMAIL = switchSendCustomerRebookReminder.EMAIL;

            $ctrl.sendCustomerSecondReminderSMS = switchSendCustomerSecondReminder.SMS;
            $ctrl.sendCustomerSecondReminderEMAIL = switchSendCustomerSecondReminder.EMAIL;

            $ctrl.sendBookingCancellationSupplierSMS = switchSendBookingCancellationSupplier.SMS;
            $ctrl.sendBookingCancellationSupplierEMAIL = switchSendBookingCancellationSupplier.EMAIL;
            
            $ctrl.sendCustomerBirthdateNoticeSMS = switchSendCustomerBirthdateNotice.SMS;
            $ctrl.sendCustomerBirthdateNoticeEmail = switchSendCustomerBirthdateNotice.EMAIL;

            $ctrl.sendCustomerWelcomeSMS = switchSendCustomerWelcome.SMS;
            $ctrl.sendCustomerWelcomeEMAIL = switchSendCustomerWelcome.EMAIL;

        }

        function switchesByNotificationType(DataType) {
            var result = {};
            result.SMS = false;
            result.EMAIL = false;
            if (DataType == null)
                return result;

            if (DataType == "SMS" || DataType == "SMS_AND_EMAIL") {
                result.SMS = true;
            }
            if (DataType == "EMAIL" || DataType == "SMS_AND_EMAIL") {
                result.EMAIL = true;
            }

            return result;
        }


        function isModernTheme() {
            if ($ctrl.settingInfo.themeSettingInfo && $ctrl.settingInfo.themeSettingInfo.themeType && $ctrl.settingInfo.themeSettingInfo.themeType == 'MODERN_THEME') {
                return true;
            }

        }

        function primaryColorSetChanged() {
            switch ($ctrl.primaryColorSet) {
                case 'RED':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_red;
                    break;
                case 'BLUE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_blue;
                    break;
                case 'GREEN':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_green;
                    break;
                case 'PINK':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_pink;
                    break;
                case 'PURPLE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_purple;
                    break;
                case 'ORANGE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_orange;
                    break;
                case 'DARKBLUE':
                    $ctrl.settingInfo.themeSettingInfo.themePrimaryColor = color_darkBlue;
                    break;
            }
        }

        function loadPrimaryColorSet() {
            if ($ctrl.settingInfo.themeSettingInfo.themePrimaryColor) {
                switch ($ctrl.settingInfo.themeSettingInfo.themePrimaryColor) {
                    case color_red:
                        $ctrl.primaryColorSet = 'RED';
                        break;
                    case color_blue:
                        $ctrl.primaryColorSet = 'BLUE';
                        break;
                    case color_green:
                        $ctrl.primaryColorSet = 'GREEN';
                        break;
                    case color_pink:
                        $ctrl.primaryColorSet = 'PINK';
                        break;
                    case color_purple:
                        $ctrl.primaryColorSet = 'PURPLE';
                        break;
                    case color_orange:
                        $ctrl.primaryColorSet = 'ORANGE';
                        break;
                    case color_darkBlue:
                        $ctrl.primaryColorSet = 'DARKBLUE';
                        break;
                    default :
                        $ctrl.primaryColorSet = 'CUSTOM';
                        break;
                }
            }
        }

        function colorSetStyle(colorName) {

            return 'color-' + colorName;
        }

        function videoPlatformChanged() {

        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                $ctrl.company = result
            });
        }

        $scope.$watch('$ctrl.settingInfo.notificationSetting', function () {
            if ($ctrl.settingInfo.notificationSetting) {
                if (!$ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier) {
                    $ctrl.settingInfo.notificationSetting.sendBookingCancellationSupplier = 'SMS';
                }

                loadSwitches();
            }
        })

        $scope.$watch('$ctrl.settingInfo.themeSettingInfo ', function () {

            if ($ctrl.settingInfo.themeSettingInfo) {

                if (!$ctrl.settingInfo.themeSettingInfo.themeType) {
                    $ctrl.settingInfo.themeSettingInfo.themeType = 'DEFAULT_THEME';
                }
                if (!$ctrl.settingInfo.themeSettingInfo.themeHeaderType)
                    $ctrl.settingInfo.themeSettingInfo.themeHeaderType = 'MODERN_HEADER';
                if (!$ctrl.settingInfo.themeSettingInfo.themeServiceListType)
                    $ctrl.settingInfo.themeSettingInfo.themeServiceListType = 'CARD';

                loadPrimaryColorSet();
            }
        })

        function imageUploaded(image) {
            if ($ctrl.onImageUploaded)
                $ctrl.onImageUploaded();
        }

    }

    var SettingInfoComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/setting-info/partial-form.setting-info.html',
        controller: SettingInfoComponentController,
        bindings:
            {
                settingInfo: '=',
                isInMarketPlace: '=',
                onImageUploaded: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfSettingInfo', SettingInfoComponent)

    SettingInfoComponentController.$inject = ['__config', '$scope', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams', 'CompanyCustom'];


})();

